<template>
  <section class="landing-page-worldwide">
    <div class="landing-page-worldwide__content">
      <h2 class="landing-page__title landing-page-worldwide__title">
        {{ $t('landingPage.worldwide.title') }}
      </h2>
      <h2 class="landing-page__title landing-page__title_bold">
        {{ $t('landingPage.worldwide.subTitle') }}
      </h2>
      <div class="landing-page-worldwide__desc">
        {{ $t('landingPage.worldwide.description.firstText') }}
        <span>{{ $t('landingPage.worldwide.description.secondText') }}</span>
      </div>
    </div>
    <div class="landing-page-worldwide__img">
      <transition
        name="fade-el"
        mode="out-in"
        appear
      >
        <v-lazy-image
          :src="require('@/assets/images/landing/worldwide-img.png')"
          :srcPlaceholder="require('@/assets/images/landing/phImage.svg')"
          alt="map"
        />
      </transition>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Worldwide',
};
</script>

<style scoped lang="scss">
@import "../../sass/variables";
@import "../../sass/mixins";

  .landing-page {

    &__title {
      & + .landing-page__title {
        margin-top: -8px;
        letter-spacing: .3px;
        margin-bottom: 12px;

        @include mobile {
          margin-top: 0;
        }
      }
    }

    &-worldwide {
      padding-top: 165px;
      background: url("../../assets/images/landing/worldwide-bg.png") no-repeat;
      text-align: center;
      background-position: 0px -664px;
      background-size: cover;

      &__content {
        position: relative;
        z-index: 10;
      }

      &__title {
        letter-spacing: 1px;
        margin-bottom: 7px;
      }

      @include tablet-landscape {
        min-height: auto;
      }

      @include only-tablet-landscape {
        padding-top: 120px;
      }

      @include mobile {
        padding-top: 95px;
        padding-bottom: 110px;
      }

      &__desc {
        font: $font-size-landing-lg $font-landing-global;
        letter-spacing: .3px;

        span {
          color: $color-dodger-blue-dark;
          font-family: $font-landing-heavy;
        }

        @include mobile {
          font-size: $font-size-landing-sm;
          max-width: 260px;
          margin: 12px auto 0;
        }
      }

      &__img {
        position: relative;
        top: -63px;
        max-width: 1486px;
        max-height: 734px;
        margin: auto;
        overflow: hidden;

        img {
          max-height: 734px;
        }

        @include mobile {
          margin-top: 25px;
        }
      }
    }
  }

@include tablet-portrait {
  .landing-page-worldwide {
    padding-top: 70px;
    padding-bottom: 30px;
  }
}

@include mobile {
  .landing-page-worldwide {
    padding-top: 50px;
    padding-bottom: 10px;
  }
}

</style>
